import "./SectionLineHeader.css";

type SectionLineHeaderProps = {
  header: string;
};

function SectionLineHeader({ header }: SectionLineHeaderProps) {
  return (
    <div className="section-line-header">
      <div className="section-line-header-wrapper">
        <h1>{header}</h1>
      </div>
    </div>
  );
}

export default SectionLineHeader;
